<template>
  <v-card outlined class="mt-4 pb-0 lighten-2">
    <v-expansion-panels flat>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-card-title>{{ spefuxe.length }} Spefüxe zum WS 2024/25</v-card-title>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card outlined class="mb-2" v-for="(item, index) in spefuxe" :key="index">
            <v-card-title class="px-0 pb-0 pt-1">
              <v-list two-line width="100%">
                <v-list-item class="font-weight-bold">
                  <v-list-item-content>
                    <v-list-item-title>{{ $filters.user(item.id, spefuxe) }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.studiengang }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-title>
            <v-card-text>
              {{ item.bemerkungen }}
            </v-card-text>
          </v-card>
          <v-card flat>
            <v-card-title class="px-0 pb-0 pt-1">
              <v-list two-line width="100%">
                <v-list-item class="font-weight-bold">
                  <v-list-item-content>
                    <v-list-item-title>Aktuelle Füxe ({{ fuxe.length }})</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-title>
            <v-card-text>
              <v-chip label small class="ma-1" v-for="(item, index) in fuxe" :key="index">
                {{ $filters.user(item.id, fuxe) }}
              </v-chip>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
  export default {
    data() {
      return {
        search: "",
      };
    },
    computed: {
      spefuxe() {
        return this.$store.state.bbrbbr.bbrbbr.filter((item) => item.status === "Spefux");
      },
      fuxe() {
        return this.$store.state.bbrbbr.bbrbbr.filter((item) => item.status === "Fux");
      },
      currentBbr() {
        return this.$getCurrentBbr();
      },
    },
  };
</script>



// WEBPACK FOOTER //
// cardHomeKeilliste.vue?57224530